import elsagaService from './elsagaService.js';

export default elsagaService;
